/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */


import {ProgressBarActionReset} from '@tunnel-store/actions/tunnel';
import {ProgressBarActionFail, ProgressBarActionSuccess} from '@tunnel-store/index';
import {Dispatch} from 'redux';
// import * as Utils from '@Cyclope-Utils/index';

/**
 * @function ProgressBarActionCreator
 * @param {}
 * @return {Promise<any>}  Promise
 */
export function ProgressBarActionCreator(): (dispatch: Dispatch<any>, {}) =>
    Promise<void> {
  return async (dispatch: Dispatch<any>) => {
    try {
      await dispatch(ProgressBarActionSuccess());

    } catch (error) {
      dispatch(ProgressBarActionFail(error.message));
    }
  }
}
/**
 * @function { ProgressBarActionCreator }
 * @param data
 * @return promise
 */
export function ProgressBarResetActionCreator(): (
    dispatch: Dispatch<any>, {}) => Promise<void> {
  return async (dispatch: Dispatch<any>) => {
    dispatch(ProgressBarActionReset());
  }
}


// WEBPACK FOOTER //
// ./src/apps/tunnel/store/actionsCreator/actions/progressbar/index.ts